var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-text',[_vm._v("Dibs")]),_c('b-button',{on:{"click":function($event){return _vm.dibsInvoke()}}},[_vm._v(" Invoke ")]),_c('div',{attrs:{"id":"dibs-complete-checkout"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }